import { TeacherHeader } from './TeacherHeader';

export default function Header() {
  return <TeacherHeader />;
}
